import { Link } from 'react-router-dom';
import React from 'react';
import { Typography } from '@mui/material';
import { CommunitiesIcon } from 'images/icons/CommunitiesIcon';
import { ListIcon } from 'images/icons/ListIcon';
import Box from '@mui/material/Box';

export const SourceTitle = ({ orderName, sourceUrl, classes }) => {
  const isSlideGroup = sourceUrl.includes('slide_groups');

  return (
    <>
      {sourceUrl.length ? (
        <Link
          className={classes.sourceLink}
          target="_blank"
          rel="noopener noreferrer"
          to={{ pathname: sourceUrl }}
        >
          <Box className={classes.sourceLinkIcon}>
            {isSlideGroup ? <CommunitiesIcon /> : <ListIcon />}
          </Box>
          {isSlideGroup ? 'Slide Group' : orderName}
        </Link>
      ) : (
        <Typography className={classes.defaultLabel}>{orderName}</Typography>
      )}
    </>
  );
};
